var exports = {
  "N": "xfd349460--279221--element",
};

module.exports = exports;
